import { compose, withPropsOnChange } from 'recompose'
import { connect } from 'react-redux'
import withTranslations from '../../core/withTranslations'
import { getUserCharityId } from '../session/index'

const mapStateToProps = state => ({
  hasUserCharity: Boolean(getUserCharityId(state))
})

const withUserCharityData = connect(mapStateToProps)

const mainMenuPath = 'app:menus.main'
const translate = withTranslations({
  homeText: `${mainMenuPath}.home`,
  eventsText: `${mainMenuPath}.events`,
  productsText: `${mainMenuPath}.products`,
  charitiesText: `${mainMenuPath}.charities`,
  registerCharityText: `${mainMenuPath}.registerCharity`,
  aboutUsText: `${mainMenuPath}.aboutUs`,
  contactText: `${mainMenuPath}.contact`,
  helpText: `${mainMenuPath}.help`
})

const withMenuItems = withPropsOnChange(['hasUserCharity'], props => {
  const {
    hasUserCharity,
    homeText,
    eventsText,
    productsText,
    charitiesText,
    registerCharityText,
    aboutUsText,
    contactText,
    helpText
  } = props
  let items = []
  items = items.concat([
    { icon: 'home', text: homeText, url: '/explore' },
    { icon: 'fundrising-events', text: eventsText, url: '/auctions' },
    { icon: 'auction-products', text: productsText, url: '/items' },
    { icon: 'charities', text: charitiesText, url: '/charities' }
  ])
  if (!hasUserCharity) {
    items.push({
      text: registerCharityText,
      className: 'simple-item',
      url: '/register-charity'
    })
  }
  items = items.concat([
    { text: aboutUsText, className: 'simple-item', url: '/about-us' },
    { text: contactText, className: 'simple-item', url: '/contact' },
    { text: helpText, className: 'simple-item', url: '/help' }
  ])
  return {
    items
  }
})

const withMainMenuItems = compose(translate, withUserCharityData, withMenuItems)

export default withMainMenuItems



// WEBPACK FOOTER //
// ./src/services/layout/MainMenu.js